/**
 * Created by yiren on 2019-08-26
 * Header
 */

import React from "react";
import style from "./style.css";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter
} from "react-router-dom";

import icon from "../../asset/atlas_logo.png";
import { storeGet, storeSetNet, storeContractAddress } from "../../tool/lstool";
import { TESTNET, NET, MAINNET } from "../../config/constant";
import { Toast } from "antd-mobile";

export default class Header extends React.Component {
  constructor(props) {
    super(props);
  }

  changeNet = () => {
    if (storeGet(NET) === MAINNET) {
      storeSetNet(TESTNET);
      storeContractAddress("");
      Toast.info("已切换至测试网", 1);
      setTimeout(function() {
        window.location.reload();
      }, 1000);
    } else {
      storeSetNet(MAINNET);
      storeContractAddress("");
      Toast.info("已切换至主网", 1);
      setTimeout(function() {
        window.location.reload();
      }, 1000);
    }
    this.setState({
      net: storeGet(NET)
    });
  };

  render() {
    return (
      <div className={style.container}>
        <div className={style.leftContainer}>
          <img
            src={icon}
            style={{ height: "40px", paddingTop: "5px", paddingBottom: "5px" }}
          />
          <button className={style.netButton} onClick={this.changeNet}>
            {storeGet(NET) === MAINNET ? "MainNet" : "TestNet"}
          </button>
        </div>
        <div className={style.rightContainer}>
          <button className={style.topButton}>
            <Link to="/" className={style.topButton}>
              提案
            </Link>
          </button>
          <button className={style.topButton}>
            <Link to="/vote" className={style.topButton}>
              投票
            </Link>
          </button>
          <button className={style.topButton}>
            <Link to="/transfer" className={style.topButton}>
              执行转账
            </Link>
          </button>
          <button className={style.topButton}>
            <Link to="/history" className={style.topButton}>
              历史提案
            </Link>
          </button>
          <button className={style.topButton}>
            <Link to="/contract" className={style.topButton}>
              治理合约
            </Link>
          </button>
        </div>
      </div>
    );
  }
}
